import EventEmitter from 'eventemitter3';
import { generateErrorMessage } from '../common/error-generator';
import { ErrorName } from '../common/error-info';
import loggerManager from './log/logger-manager';

/**
 * 封装 emitter.emit 方法，避免 SDK 捕获到接入侧的 error
 * @param {EventEmitter} emitter
 * @returns
 */
export const catchEmitterError = (emitter: EventEmitter, name: string) => {
  const { emit } = emitter;
  emitter.emit = (...args: any) => {
    try {
      return emit.apply(emitter, args);
    } catch (error: any) {
      const message = generateErrorMessage({
        key: ErrorName.CATCH_HANDLER_ERROR,
        data: { name, event: args[0] },
        addDocLink: false
      });
      loggerManager.warn(`${message}\n\n${error.stack}`);
      return false;
    }
  };
  return emitter;
};
